import { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import { BrowserRouter as Router } from "react-router-dom";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon4 from "../assets/images/github.svg";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [isMediumScreen, setIsMediumScreen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [expanded, setExpanded] = useState(false); 
  const navbarRef = useRef(null); 

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const checkScreenSize = () => {
      setIsMediumScreen(window.innerWidth <= 1200);
      setIsSmallScreen(window.innerWidth <= 990 && window.innerWidth >= 770);
    };

    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false); 
      }
    };

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", checkScreenSize);
    document.addEventListener("mousedown", handleClickOutside);

    checkScreenSize();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", checkScreenSize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
    setExpanded(false); // ✅ Close dropdown on click
  };

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""} expanded={expanded} ref={navbarRef}>
        <Container>
          {/* ✅ Navbar Toggle - Close on Click */}
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : true)}
          >
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {!isSmallScreen && (
                <Nav.Link href="#home" className={activeLink === "home" ? "active navbar-link" : "navbar-link"} onClick={() => onUpdateActiveLink("home")}>
                  About Me
                </Nav.Link>
              )}
              <Nav.Link href="#education-skill" className={activeLink === "education-skill" ? "active navbar-link" : "navbar-link"} onClick={() => onUpdateActiveLink("education-skill")}>
                Education
              </Nav.Link>
              <Nav.Link href="#experience" className={activeLink === "experience" ? "active navbar-link" : "navbar-link"} onClick={() => onUpdateActiveLink("experience")}>
                Experience
              </Nav.Link>
              <Nav.Link href="#skills" className={activeLink === "skills" ? "active navbar-link" : "navbar-link"} onClick={() => onUpdateActiveLink("skills")}>
                Skills
              </Nav.Link>
              <Nav.Link href="#projects" className={activeLink === "projects" ? "active navbar-link" : "navbar-link"} onClick={() => onUpdateActiveLink("projects")}>
                Projects
              </Nav.Link>
              <Nav.Link href="https://drive.google.com/file/d/1l61dBfkPd062O3H9eaCk6wWtj771LDRe/view?usp=sharing" target="_blank" className="navbar-link">
                Resume
              </Nav.Link>
              {isMediumScreen && (
                <Nav.Link href="#connect" className="navbar-link" onClick={() => onUpdateActiveLink("connect")}>
                  Contact
                </Nav.Link>
              )}
            </Nav>
            <span className="navbar-text">
              {!isMediumScreen && ( // Hide icons on medium screens
                <div className="social-icon">
                  <a href="https://github.com/mohitarora786" target="_blank">
                    <img src={navIcon4} alt="Github" />
                  </a>
                  <a href="https://www.linkedin.com/in/mohit-arora-018600229/" target="_blank">
                    <img src={navIcon1} alt="LinkedIn" />
                  </a>
                </div>
              )}
              {!isMediumScreen && ( // Hide "Let's Connect" button on medium screens
                <HashLink to="#connect">
                  <button className="vvd">
                    <span>Let’s Connect</span>
                  </button>
                </HashLink>
              )}
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
